'use client';

import { useMemo } from 'react';
import type { ToolTaskType } from '@/app/types';

interface UseToolFormValidationOptions {
  taskType: ToolTaskType;
}

export const useToolFormValidation = ({ taskType }: UseToolFormValidationOptions): string => {
  return useMemo(() => {
    void taskType;
    return '';
  }, [taskType]);
};
